import { toISOString } from './timestamp';

const TIMESTAMP_FIELDS = [
  'createdAt',
  'updatedAt',
  'deletedAt',
  'lastLogin',
  'lastSeen',
  'lastMessageAt',
  'viewedAt',
  'expiryDate',
  'timestamp',
];

export const mapFirestoreDoc = (id, data = {}) => {
  const mapped = { id, ...data };

  TIMESTAMP_FIELDS.forEach((field) => {
    if (mapped[field]) {
      mapped[field] = toISOString(mapped[field]);
    }
  });

  return mapped;
};

export const getUserRef = (record) =>
  record.userUid ||
  record.userId ||
  record.uid ||
  record.viewerId ||
  record.fromUserId ||
  record.blockerId ||
  record.ownerId ||
  null;

export const formatCellValue = (value) => {
  if (value === null || value === undefined || value === '') return '—';
  if (typeof value === 'boolean') return value ? 'Yes' : 'No';
  if (Array.isArray(value)) return value.join(', ');
  if (typeof value === 'object') return JSON.stringify(value);
  return String(value);
};
